import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const testData = [
  { mediumId: 1, name1: "Media 1", name2: "Publisher 1" },
  { mediumId: 2, name1: "Media 2", name2: "Publisher 2" },
  { mediumId: 3, name1: "Media 3", name2: "Publisher 3" }
];

const DetailComponent = (props) => (
  <div style={{ padding: 20, background: "#f0f0f0" }}>
    Detail for Media ID: {props.dataItem.mediumId}
  </div>
);

export default function AssignedMediaGridTest() {
  // Uncontrolled expansion workaround

  return (
    <Grid
      data={testData}
      defaultDetailExpand={{}}
      detail={DetailComponent}
      dataItemKey="mediumId"
    >
      <Column field="mediumId" title="Id" width="100px" />
      <Column field="name1" title="Name" />
      <Column field="name2" title="Publisher" />
    </Grid>
  );
}
